import React, { FC } from 'react'

import { useLazyLoadQuery, graphql } from 'react-relay'

import { GuildCard } from '@components'

import { GuildCardEmbedQuery } from './__generated__/GuildCardEmbedQuery.graphql'

export const GuildCardEmbed: FC<{ slug: string; expand?: boolean }> = ({
  slug,
  expand = true,
}) => {
  const data = useLazyLoadQuery<GuildCardEmbedQuery>(
    graphql`
      query GuildCardEmbedQuery($slug: String!) {
        nodeBySlugId(id: $slug) {
          __typename

          ... on Guild {
            ...GuildCard_guild
          }
        }
      }
    `,
    { slug }
  )

  if (data.nodeBySlugId?.__typename !== 'Guild') {
    console.error(`GuildCardEmbed: Could not find Guild with ID "${slug}"`)

    return null
  }

  return <GuildCard guild={data.nodeBySlugId} expand={expand} />
}

export default GuildCardEmbed
